export interface SearchableRecipe {
  itemId?: string;
  resolvedName?: string;
  group?: string;
}

const normalize = (value: unknown): string => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLocaleLowerCase('vi')
  .trim();

export const filterRecipes = <T extends SearchableRecipe>(recipes: T[], search: string): T[] => {
  const query = normalize(search);
  if (!query) return recipes;
  return recipes.filter((recipe) => [recipe.resolvedName, recipe.itemId, recipe.group]
    .some((value) => normalize(value).includes(query)));
};
